import axios from 'axios';

function login(email,pass){
    return axios.post('auth/login',{
        email:email,
        pass:pass,
    });
}

function recoverPassword(email){
    return axios.post('auth/recover/password',{
        email:email
    });
}

function usermeTK(query = null){
    return axios.get('auth/checkmetk',{
        params: query
    });
}

function logout(){
    return axios.post('logout');
}

const AuthService = {
    login,
    recoverPassword,
    logout,
    usermeTK
};
export default AuthService;